import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagPT = function FlagPT() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
    fill: "#6DA544",
    d: "M0 25c0 10.75 6.784 19.913 16.304 23.445L18.478 25 16.304 1.555C6.784 5.088 0 14.251 0 25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M50 25C50 11.193 38.807 0 25 0c-3.058 0-5.988.55-8.696 1.555v46.89A24.945 24.945 0 0 0 25 50c13.807 0 25-11.193 25-25Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FFDA44",
    d: "M16.304 33.696a8.696 8.696 0 1 0 0-17.392 8.696 8.696 0 0 0 0 17.392Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D80027",
    d: "M11.413 20.653v5.435a4.891 4.891 0 1 0 9.782 0v-5.435h-9.782Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F0F0F0",
    d: "M16.305 27.717c-.899 0-1.63-.731-1.63-1.63v-2.174h3.26v2.174c0 .899-.731 1.63-1.63 1.63Z"
  }));
};
FlagPT.displayName = 'FlagPT';
export default withFlagWrapper(FlagPT);
//# sourceMappingURL=index.js.map